import { v4 as uuidv4 } from "uuid";

import { Factory } from "@/data/dao/Factory";
import { type IOfflineStorage, OfflineStorage } from "@/data/dao/offline/OfflineStorage";
import { config } from "@/data/util/Config";

export class UserSessionService {
    private offlineStorage: IOfflineStorage;
    private sessionId?: string;

    constructor() {
        this.offlineStorage = Factory.getInstance<IOfflineStorage>(OfflineStorage);
    }

    public getSessionId(): string {
        if (this.sessionId === undefined) {
            this.sessionId = this.initSession();
        }

        return this.sessionId;
    }

    private initSession(): string {
        let sessionId = this.offlineStorage.readString(config.sessionIdCookieName);
        if (sessionId === null) {
            sessionId = uuidv4();
            this.offlineStorage.writeString(config.sessionIdCookieName, sessionId);
        }

        return sessionId;
    }

    public static getClassName(): string {
        return "UserSessionService";
    }
}
